var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconWrite2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.971 1.679L8.323 4.031L2.356 10H0V7.638L0.09 7.548L5.971 1.679ZM8.334 0C9.254 0 10 0.748 10 1.67C10 2.069 9.859 2.447 9.606 2.746L9.589 2.766L9.031 3.323L6.679 0.973L7.259 0.394C7.56 0.141 7.937 0 8.335 0H8.334Z"
  })));
}
export default SvgCommonIconWrite2;